
import CalendarEdit from "../../../assets/outline/CalendarEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CalendarEditIcon({ className, dataTestid = "CalendarEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CalendarEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
